import React from 'react'

import PropTypes from 'prop-types'

import './index.less'
import { Spinner } from 'components/Spinner'
import giphyLogo from '/public/img/giphy-1.png'

export const GifsCarousel = ({ selectGif, gifsUrl, fetched }) => {
  return (
    <div
      className='hide-lg show-sm'
      style={{ height: 'auto', backgroundColor: 'white' }}
    >
      <div className='scrolling-wrapper'>
        {fetched ? (
          gifsUrl.map(gif => (
            <div key={gif.fixed_width.url} className='card'>
              <img
                onClick={() => selectGif(gif.original.url)}
                src={gif.fixed_width.url}
                id='carousel-gif'
              />
            </div>
          ))
        ) : (
          <Spinner />
        )}
      </div>
      {fetched && (
        <img
          align='right'
          style={{ height: '20px', marginBottom: '4px', marginRight: '10px' }}
          src={giphyLogo}
        />
      )}
    </div>
  )
}
GifsCarousel.propTypes = {
  /** An array of the fetched gifs url */
  gifsUrl: PropTypes.array.isRequired,

  /** Function to be called when the user chooses the gif from the list */
  selectGif: PropTypes.func.isRequired,

  /** Boolean value representing the search status on the giphy api */
  fetched: PropTypes.bool.isRequired,
}
